(function() {
  // Temporary redirect for consolidated Cloak Hook and Loop pages
  const currentPath = window.location.pathname;
  const newUrl = '/products/cloak-hook-and-loop-holster';

  // Match patterns: /products/cloak-hook-and-loop-holster-for-*, /products/cloak-hook-and-loop-for-*, /products/cloak-hook-for-*
  // and general wildcard patterns: /products/cloak-hook-and-loop-holster-*, /products/cloak-hook-and-loop-*, /products/cloak-hook-*
  const redirectPatterns = [
    /^\/products\/cloak-hook-and-loop-holster-for-.+$/i,
    /^\/products\/cloak-hook-and-loop-for-.+$/i,
    /^\/products\/cloak-hook-for-.+$/i,
    /^\/products\/cloak-hook-and-loop-holster-.+$/i,
    /^\/products\/cloak-hook-and-loop-.+$/i,
    /^\/products\/cloak-hook-.+$/i
  ];

  // Check if current URL matches any redirect pattern
  const shouldRedirect = redirectPatterns.some(pattern => pattern.test(currentPath));

  if (shouldRedirect && currentPath !== newUrl) {
    window.location.replace(newUrl);
  }
})();
